import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getVideo } from './videoAPI';

const initialState = {
    isSuccess: false,
    video: {},
    isLoading: false,
    isError: false,
    error: null,
};

export const fetchVideo = createAsyncThunk('video/fetchVideo', async (id) => {
    const video = await getVideo(id);
    return video;
});

export const hitLike = createAsyncThunk('video/hitLike', async ({ id, likes }, thunkApi) => {
    try {
        const res = await fetch(`https://video-app-sr5.herokuapp.com/videos/${id}`, {

            method: 'PATCH',
            body: JSON.stringify({
                likes: likes + 1,
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
        })
        const data = await res.json();
        return data;
    } catch (error) {
        const message = error.response.data.message;
        return thunkApi.rejectWithValue(message);
    }
}

)
export const hitDisLike = createAsyncThunk('video/hitDisLike', async ({ id, unlikes }, thunkApi) => {
    try {
        const res = await fetch(`https://video-app-sr5.herokuapp.com/videos/${id}`, {

            method: 'PATCH',
            body: JSON.stringify({
                unlikes: unlikes + 1,
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
        })
        const data = await res.json();
        return data;
    } catch (error) {
        const message = error.response.data.message;
        return thunkApi.rejectWithValue(message);
    }
}

)

const videoSlice = createSlice({
    name: 'video',
    initialState,
    reducers: {
        setDislike: (state, action) => {
            state.video.unlikes = state.video.unlikes += 1;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchVideo.pending, (state, action) => {
            state.isError = false;
            state.isLoading = true;
        }).addCase(fetchVideo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.video = action.payload;
        }).addCase(fetchVideo.rejected, (state, action) => {
            state.isLoading = false;
            state.video = {};
            state.isError = true;
            state.error = action.error?.message;
        }).addCase(hitLike.fulfilled, (state, action) => {
            state.video = action.payload;
            state.isError = false;
            state.isLoading = false;
        }).addCase(hitLike.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action.payload
        }).addCase(hitDisLike.fulfilled, (state, action) => {
            state.video = action.payload;
            state.isError = false;
            state.isLoading = false;
        }).addCase(hitDisLike.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action.payload
        })
    },
});

export default videoSlice.reducer;
export const { setLike, setDislike } = videoSlice.actions;